import type { Ref } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import capitalMarketsService from '../services/capitalMarketsService';

interface UseCessionDetailParams {
  page?: number;
  page_size?: number;
}

export default function useCessionDetail(
  cessionId: Ref<number>,
  params?: Ref<UseCessionDetailParams>,
) {
  return useQuery({
    enabled: () => Boolean(cessionId.value),
    queryFn: () => capitalMarketsService.getDetail(cessionId.value, params?.value),
    queryKey: ['cession', 'detail', cessionId, params],
  });
}
